import { Avatar } from '@mui/material';
import { NotificationClass } from '../../core/interfaces/notification.interface';
import SchoolIcon from '@mui/icons-material/School';

const ClassNotification = ({ notification }: { notification: NotificationClass }) => {
  return (
    <>
      <Avatar src={notification?.course?.avatar}>
        <SchoolIcon fontSize="large" />
      </Avatar>
      <div style={{ marginLeft: '5px', textWrap: 'wrap' }}>
        <div style={{ fontSize: '1rem', color: '#c4c4c4' }}>Nueva clase</div>
        <div>Se ha agregado una nueva clase al curso {notification?.course?.name ?? ''}</div>
        <div style={{ color: '#c2c2c2', height: '20px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {notification?.class?.name}
        </div>
      </div>
    </>
  );
};

export default ClassNotification;
